webpackJsonp([2335091871432551400],{

/***/ "./data/community.js":
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = [];

/***/ }),

/***/ "./data/products.js":
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = [{
	  name: "TBA."
	}];

/***/ }),

/***/ "./node_modules/react-md/lib/Cards/Card.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/react/react.js"), __webpack_require__("./node_modules/prop-types/index.js"), __webpack_require__("./node_modules/classnames/index.js"), __webpack_require__("./node_modules/react-prop-types/lib/deprecated.js"), __webpack_require__("./node_modules/react-md/lib/utils/PropTypes/controlled.js"), __webpack_require__("./node_modules/react-md/lib/utils/getField.js"), __webpack_require__("./node_modules/react-md/lib/Cards/contextTypes.js"), __webpack_require__("./node_modules/react-md/lib/Papers/Paper.js"), __webpack_require__("./node_modules/react-md/lib/Helpers/Collapse.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/PropTypes/controlled'), require('../utils/getField'), require('./contextTypes'), require('../Papers/Paper'), require('../Helpers/Collapse'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.controlled, global.getField, global.contextTypes, global.Paper, global.Collapse);
	    global.Card = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _controlled, _getField, _contextTypes, _Paper, _Collapse) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	  var _Paper2 = _interopRequireDefault(_Paper);
	
	  var _Collapse2 = _interopRequireDefault(_Collapse);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Card = function (_PureComponent) {
	    _inherits(Card, _PureComponent);
	
	    function Card(props) {
	      _classCallCheck(this, Card);
	
	      var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));
	
	      _this.state = {
	        zDepth: 1,
	        expanded: typeof props.initiallyExpanded !== 'undefined' ? props.initiallyExpanded : !!props.defaultExpanded
	      };
	      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
	      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	      _this._handleExpandClick = _this._handleExpandClick.bind(_this);
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      return _this;
	    }
	
	    _createClass(Card, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        var _props = this.props,
	            iconClassName = _props.iconClassName,
	            iconChildren = _props.iconChildren,
	            expanderTooltipLabel = _props.expanderTooltipLabel,
	            expanderTooltipDelay = _props.expanderTooltipDelay,
	            expanderTooltipPosition = _props.expanderTooltipPosition,
	            expanderIconClassName = _props.expanderIconClassName,
	            expanderIconChildren = _props.expanderIconChildren;
	
	
	        var expanded = typeof this.props.isExpanded !== 'undefined' ? this.props.isExpanded : (0, _getField2.default)(this.props, this.state, 'expanded');
	
	        return {
	          expanded: expanded,
	          onExpandClick: this._handleExpandClick,
	          iconClassName: typeof iconClassName !== 'undefined' ? iconClassName : expanderIconClassName,
	          iconChildren: typeof iconChildren !== 'undefined' ? iconChildren : expanderIconChildren,
	          tooltipLabel: expanderTooltipLabel,
	          tooltipDelay: expanderTooltipDelay,
	          tooltipPosition: expanderTooltipPosition
	        };
	      }
	    }, {
	      key: '_handleMouseOver',
	      value: function _handleMouseOver(e) {
	        if (this.props.onMouseOver) {
	          this.props.onMouseOver(e);
	        }
	
	        if (this.props.raise && !this._touched) {
	          this.setState({ zDepth: 4 });
	        }
	      }
	    }, {
	      key: '_handleMouseLeave',
	      value: function _handleMouseLeave(e) {
	        if (this.props.onMouseLeave) {
	          this.props.onMouseLeave(e);
	        }
	
	        this._touched = false;
	        if (this.props.raise && this.state.zDepth !== 1) {
	          this.setState({ zDepth: 1 });
	        }
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart(e) {
	        if (this.props.onTouchStart) {
	          this.props.onTouchStart(e);
	        }
	
	        this._touched = true;
	      }
	    }, {
	      key: '_handleExpandClick',
	      value: function _handleExpandClick(e) {
	        var onExpanderClick = this.props.onExpanderClick;
	
	        var expanded = !(0, _getField2.default)(this.props, this.state, 'expanded');
	        if (onExpanderClick) {
	          onExpanderClick(expanded, e);
	        }
	
	        if (typeof this.props.expanded === 'undefined') {
	          this.setState({ expanded: expanded });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var zDepth = this.state.zDepth;
	
	        var _props2 = this.props,
	            className = _props2.className,
	            raise = _props2.raise,
	            tableCard = _props2.tableCard,
	            children = _props2.children,
	            props = _objectWithoutProperties(_props2, ['className', 'raise', 'tableCard', 'children']);
	
	        delete props.expanded;
	        delete props.isExpanded;
	        delete props.onExpanderClick;
	        delete props.initiallyExpanded;
	        delete props.defaultExpanded;
	        delete props.iconChildren;
	        delete props.iconClassName;
	        delete props.expanderIconChildren;
	        delete props.expanderIconClassName;
	        delete props.expanderTooltipLabel;
	        delete props.expanderTooltipDelay;
	        delete props.expanderTooltipPosition;
	
	        var expanded = typeof this.props.isExpanded !== 'undefined' ? this.props.isExpanded : (0, _getField2.default)(this.props, this.state, 'expanded');
	        var expanderIndex = -1;
	        var parts = _react.Children.map(_react.Children.toArray(children), function (child, i) {
	          if (!child || !child.props) {
	            return child;
	          } else if (expanderIndex < 0 && (child.props.isExpander || child.props.expander)) {
	            expanderIndex = i;
	          }
	
	          if (!child.props.expandable) {
	            return child;
	          }
	
	          var collapsed = expanderIndex === -1 || expanderIndex === i || !expanded;
	          return _react2.default.createElement(
	            _Collapse2.default,
	            { collapsed: collapsed },
	            child
	          );
	        });
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          _extends({}, props, {
	            zDepth: zDepth,
	            className: (0, _classnames2.default)('md-card', {
	              'md-card--raise': raise,
	              'md-card--table': tableCard
	            }, 'md-background--card', className),
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave,
	            onTouchStart: this._handleTouchStart
	          }),
	          parts
	        );
	      }
	    }]);
	
	    return Card;
	  }(_react.PureComponent);
	
	  Card.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _propTypes2.default.object,
	
	    /**
	     * An optional className to apply to the card.
	     */
	    className: _propTypes2.default.string,
	
	    /**
	     * Any Card parts that should be rendered.
	     */
	    children: _propTypes2.default.node,
	
	    /**
	     * Boolean if the card is expanded by default when there is an expander
	     * component.
	     */
	    defaultExpanded: _propTypes2.default.bool,
	
	    /**
	     * Boolean if the card should raise on hover when on a desktop display.
	     */
	    raise: _propTypes2.default.bool,
	
	    /**
	     * Boolean if the card is currently expanded. This will require the `onExpanderClick` function
	     * to toggle the state. The card will become controlled if this is not `undefined`.
	     */
	    expanded: (0, _controlled2.default)(_propTypes2.default.bool, 'onExpanderClick', 'defaultExpanded'),
	
	    /**
	     * An optional function to call when the expander is clicked.
	     */
	    onExpanderClick: _propTypes2.default.func,
	
	    /**
	     * The icon className to use for the expander icon.
	     */
	    expanderIconClassName: _propTypes2.default.string,
	
	    /**
	     * Any icon children required for the expander icon.
	     */
	    expanderIconChildren: _propTypes2.default.node,
	
	    /**
	     * The tooltip position for the expander icon.
	     */
	    expanderTooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * The optional tooltip to display for the expander icon.
	     */
	    expanderTooltipLabel: _propTypes2.default.node,
	
	    /**
	     * An optional delay before the tooltip appears for the expander icon on hover.
	     */
	    expanderTooltipDelay: _propTypes2.default.number,
	
	    /**
	     * Boolean if the card contains a table. It will update the styling accordingly.
	     * When using the `DataTable` component, do not wrap it in a `CardText` component.
	     *
	     * ```js
	     * <Card tableCard={true}>
	     *   <CardTitle title="Example />
	     *   <DataTable>
	     *     ...
	     *   </DataTable>
	     * </Card>
	     * ```
	     */
	    tableCard: _propTypes2.default.bool,
	
	    /**
	     * An optional function to call when the mouseover event is triggered.
	     */
	    onMouseOver: _propTypes2.default.func,
	
	    /**
	     * An optional function to call when the mouseleave event is triggered.
	     */
	    onMouseLeave: _propTypes2.default.func,
	
	    /**
	     * An optional function to call when the touchstart event is triggered.
	     */
	    onTouchStart: _propTypes2.default.func,
	    initiallyExpanded: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `defaultExpanded` instead'),
	    isExpanded: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expanded` instead'),
	    iconChildren: (0, _deprecated2.default)(_propTypes2.default.node, 'Use the `expanderIconChildren` prop instead'),
	    iconClassName: (0, _deprecated2.default)(_propTypes2.default.string, 'Use the `expanderIconClassName` prop instead')
	  };
	  Card.defaultProps = {
	    expanderIconChildren: 'keyboard_arrow_down',
	    expanderIconClassName: 'material-icons',
	    expanderTooltipPosition: 'left'
	  };
	  Card.childContextTypes = _contextTypes2.default;
	  exports.default = Card;
	});

/***/ }),

/***/ "./node_modules/react-md/lib/Cards/CardExpander.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/react/react.js"), __webpack_require__("./node_modules/classnames/index.js"), __webpack_require__("./node_modules/react-md/lib/Cards/contextTypes.js"), __webpack_require__("./node_modules/react-md/lib/Buttons/Button.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('./contextTypes'), require('../Buttons/Button'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.contextTypes, global.Button);
	    global.CardExpander = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _contextTypes, _Button) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardExpander = function (_Component) {
	    _inherits(CardExpander, _Component);
	
	    function CardExpander() {
	      _classCallCheck(this, CardExpander);
	
	      return _possibleConstructorReturn(this, (CardExpander.__proto__ || Object.getPrototypeOf(CardExpander)).apply(this, arguments));
	    }
	
	    _createClass(CardExpander, [{
	      key: 'render',
	      value: function render() {
	        var _context = this.context,
	            expanded = _context.expanded,
	            onExpandClick = _context.onExpandClick,
	            iconClassName = _context.iconClassName,
	            iconChildren = _context.iconChildren,
	            tooltipPosition = _context.tooltipPosition,
	            tooltipLabel = _context.tooltipLabel,
	            tooltipDelay = _context.tooltipDelay;
	
	
	        return _react2.default.createElement(
	          _Button2.default,
	          {
	            icon: true,
	            className: (0, _classnames2.default)('md-collapser md-collapser--card', {
	              'md-collapser--flipped': expanded
	            }),
	            onClick: onExpandClick,
	            iconClassName: iconClassName,
	            tooltipLabel: tooltipLabel,
	            tooltipDelay: tooltipDelay,
	            tooltipPosition: tooltipPosition
	          },
	          iconChildren
	        );
	      }
	    }]);
	
	    return CardExpander;
	  }(_react.Component);
	
	  CardExpander.contextTypes = _contextTypes2.default;
	  exports.default = CardExpander;
	});

/***/ }),

/***/ "./node_modules/react-md/lib/Cards/CardText.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/react/react.js"), __webpack_require__("./node_modules/prop-types/index.js"), __webpack_require__("./node_modules/classnames/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('prop-types'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes, global.classnames);
	    global.CardText = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardText = function (_PureComponent) {
	    _inherits(CardText, _PureComponent);
	
	    function CardText() {
	      _classCallCheck(this, CardText);
	
	      return _possibleConstructorReturn(this, (CardText.__proto__ || Object.getPrototypeOf(CardText)).apply(this, arguments));
	    }
	
	    _createClass(CardText, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            Component = _props.component,
	            className = _props.className,
	            props = _objectWithoutProperties(_props, ['component', 'className']);
	
	        delete props.expandable;
	
	        return _react2.default.createElement(Component, _extends({}, props, { className: (0, _classnames2.default)('md-card-text', className) }));
	      }
	    }]);
	
	    return CardText;
	  }(_react.PureComponent);
	
	  CardText.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _propTypes2.default.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _propTypes2.default.string,
	
	    /**
	     * The children to display.
	     */
	    children: _propTypes2.default.node,
	
	    /**
	     * The component to render as.
	     */
	    component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	
	    /**
	     * Boolean if this component should be expandable when there is a `CardExpander`
	     * above it in the `Card`.
	     */
	    expandable: _propTypes2.default.bool
	  };
	  CardText.defaultProps = {
	    component: 'section'
	  };
	  exports.default = CardText;
	});

/***/ }),

/***/ "./node_modules/react-md/lib/Cards/CardTitle.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/react/react.js"), __webpack_require__("./node_modules/prop-types/index.js"), __webpack_require__("./node_modules/classnames/index.js"), __webpack_require__("./node_modules/react-prop-types/lib/deprecated.js"), __webpack_require__("./node_modules/react-md/lib/Cards/CardTitleBlock.js"), __webpack_require__("./node_modules/react-md/lib/Cards/CardExpander.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('prop-types'), require('classnames'), require('react-prop-types/lib/deprecated'), require('./CardTitleBlock'), require('./CardExpander'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes, global.classnames, global.deprecated, global.CardTitleBlock, global.CardExpander);
	    global.CardTitle = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes, _classnames, _deprecated, _CardTitleBlock, _CardExpander) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _CardTitleBlock2 = _interopRequireDefault(_CardTitleBlock);
	
	  var _CardExpander2 = _interopRequireDefault(_CardExpander);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardTitle = function (_Component) {
	    _inherits(CardTitle, _Component);
	
	    function CardTitle() {
	      _classCallCheck(this, CardTitle);
	
	      return _possibleConstructorReturn(this, (CardTitle.__proto__ || Object.getPrototypeOf(CardTitle)).apply(this, arguments));
	    }
	
	    _createClass(CardTitle, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            id = _props.id,
	            style = _props.style,
	            className = _props.className,
	            title = _props.title,
	            subtitle = _props.subtitle,
	            expander = _props.expander,
	            isExpander = _props.isExpander,
	            children = _props.children,
	            props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'title', 'subtitle', 'expander', 'isExpander', 'children']);
	
	        delete props.avatar;
	        var avatar = this.props.avatar;
	
	        if (avatar) {
	          var avatarClassName = _react.Children.only(avatar).props.className;
	
	          avatar = (0, _react.cloneElement)(avatar, {
	            className: (0, _classnames2.default)('md-avatar--card', avatarClassName)
	          });
	        }
	        return _react2.default.createElement(
	          'div',
	          _extends({}, props, {
	            style: style,
	            className: (0, _classnames2.default)('md-card-title', {
	              'md-card-title--primary': !avatar
	            }, className)
	          }),
	          avatar,
	          _react2.default.createElement(_CardTitleBlock2.default, { id: id, title: title, subtitle: subtitle, avatar: !!avatar }),
	          children,
	          isExpander || expander && _react2.default.createElement(_CardExpander2.default, null)
	        );
	      }
	    }]);
	
	    return CardTitle;
	  }(_react.Component);
	
	  CardTitle.propTypes = {
	    /**
	     * An optional id to add to the `title`.
	     */
	    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	    /**
	     * An optional style to apply.
	     */
	    style: _propTypes2.default.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _propTypes2.default.string,
	
	    /**
	     * The title to display.
	     */
	    title: _propTypes2.default.node.isRequired,
	
	    /**
	     * An optional subtitle to display.
	     */
	    subtitle: _propTypes2.default.node,
	
	    /**
	     * Any additional children to display in the title block
	     * after the avatar, title, and subtitle.
	     */
	    children: _propTypes2.default.node,
	
	    /**
	     * An optional avatar to display before the title and subtitle.
	     */
	    avatar: _propTypes2.default.element,
	
	    /**
	     * Boolean if the `CardTitle` component should inject a button
	     * for expanding all children below it.
	     */
	    expander: _propTypes2.default.bool,
	
	    isExpander: (0, _deprecated2.default)(_propTypes2.default.bool, 'Use `expander` instead')
	  };
	  exports.default = CardTitle;
	});

/***/ }),

/***/ "./node_modules/react-md/lib/Cards/CardTitleBlock.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/react/react.js"), __webpack_require__("./node_modules/prop-types/index.js"), __webpack_require__("./node_modules/classnames/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('prop-types'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes, global.classnames);
	    global.CardTitleBlock = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardTitleBlock = function (_PureComponent) {
	    _inherits(CardTitleBlock, _PureComponent);
	
	    function CardTitleBlock() {
	      _classCallCheck(this, CardTitleBlock);
	
	      return _possibleConstructorReturn(this, (CardTitleBlock.__proto__ || Object.getPrototypeOf(CardTitleBlock)).apply(this, arguments));
	    }
	
	    _createClass(CardTitleBlock, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            id = _props.id,
	            subtitle = _props.subtitle,
	            avatar = _props.avatar;
	        var title = this.props.title;
	
	        title = _react2.default.createElement(
	          'h2',
	          {
	            id: id,
	            className: (0, _classnames2.default)('md-card-title--title md-text', {
	              'md-card-title--large': !avatar
	            })
	          },
	          title
	        );
	
	        if (!subtitle) {
	          return title;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'md-card-title--title-block' },
	          title,
	          _react2.default.createElement(
	            'h3',
	            { className: 'md-card-title--title md-text--secondary' },
	            subtitle
	          )
	        );
	      }
	    }]);
	
	    return CardTitleBlock;
	  }(_react.PureComponent);
	
	  CardTitleBlock.propTypes = {
	    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    title: _propTypes2.default.node.isRequired,
	    subtitle: _propTypes2.default.node,
	    avatar: _propTypes2.default.bool
	  };
	  exports.default = CardTitleBlock;
	});

/***/ }),

/***/ "./node_modules/react-md/lib/Cards/contextTypes.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/prop-types/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('prop-types'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.propTypes);
	    global.contextTypes = mod.exports;
	  }
	})(this, function (exports, _propTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = {
	    onExpandClick: _propTypes2.default.func,
	    expanded: _propTypes2.default.bool,
	    iconClassName: _propTypes2.default.string,
	    iconChildren: _propTypes2.default.node,
	    tooltipPosition: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	    tooltipLabel: _propTypes2.default.node,
	    tooltipDelay: _propTypes2.default.number
	  };
	});

/***/ }),

/***/ "./node_modules/react-md/lib/Media/Media.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/react/react.js"), __webpack_require__("./node_modules/prop-types/index.js"), __webpack_require__("./node_modules/classnames/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('prop-types'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes, global.classnames);
	    global.Media = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  function validateAspectRatio(props, propName, component) {
	    var _PropTypes$string;
	
	    var value = props[propName];
	
	    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      args[_key - 3] = arguments[_key];
	    }
	
	    var err = (_PropTypes$string = _propTypes2.default.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(args));
	    if (!err && value.split('-').length !== 2) {
	      err = new Error('Your provided an `' + propName + '` prop to the ' + component + ' that is not a valid ' + ('aspect ratio `' + value + '`. This should be in the form of \'{width}-{height}\'.'));
	    }
	
	    return err;
	  }
	
	  /**
	   * The `Media` component is used to display images, iframes, ...media. Who'da thunk?
	   */
	
	  var Media = function (_PureComponent) {
	    _inherits(Media, _PureComponent);
	
	    function Media() {
	      _classCallCheck(this, Media);
	
	      return _possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).apply(this, arguments));
	    }
	
	    _createClass(Media, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            Component = _props.component,
	            className = _props.className,
	            children = _props.children,
	            forceAspect = _props.forceAspect,
	            aspectRatio = _props.aspectRatio,
	            props = _objectWithoutProperties(_props, ['component', 'className', 'children', 'forceAspect', 'aspectRatio']);
	
	        delete props.expandable;
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-media', _defineProperty({}, 'md-media--' + aspectRatio, forceAspect), className)
	          }),
	          children
	        );
	      }
	    }]);
	
	    return Media;
	  }(_react.PureComponent);
	
	  Media.propTypes = {
	    /**
	     * An optional className to apply to the card media component.
	     */
	    className: _propTypes2.default.string,
	
	    /**
	     * Any media to display.
	     */
	    children: _propTypes2.default.node,
	
	    /**
	     * Boolean if the aspect ratio should be forced.
	     */
	    forceAspect: _propTypes2.default.bool,
	
	    /**
	     * The aspect ratio to use.
	     */
	    aspectRatio: validateAspectRatio,
	
	    /**
	     * Boolean if this component should be expandable when there is a `CardExpander`
	     * above it in the `Card`.
	     */
	    expandable: _propTypes2.default.bool,
	
	    /**
	     * The component to render the card media as.
	     */
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	  };
	  Media.defaultProps = {
	    forceAspect: true,
	    aspectRatio: '16-9',
	    component: 'section'
	  };
	  exports.default = Media;
	});

/***/ }),

/***/ "./node_modules/react-md/lib/Media/MediaOverlay.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/react/react.js"), __webpack_require__("./node_modules/prop-types/index.js"), __webpack_require__("./node_modules/classnames/index.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('prop-types'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes, global.classnames);
	    global.MediaOverlay = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var MediaOverlay = function (_PureComponent) {
	    _inherits(MediaOverlay, _PureComponent);
	
	    function MediaOverlay() {
	      _classCallCheck(this, MediaOverlay);
	
	      return _possibleConstructorReturn(this, (MediaOverlay.__proto__ || Object.getPrototypeOf(MediaOverlay)).apply(this, arguments));
	    }
	
	    _createClass(MediaOverlay, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            Component = _props.component,
	            props = _objectWithoutProperties(_props, ['className', 'component']);
	
	        return _react2.default.createElement(Component, _extends({ className: (0, _classnames2.default)('md-media-overlay', className) }, props));
	      }
	    }]);
	
	    return MediaOverlay;
	  }(_react.PureComponent);
	
	  MediaOverlay.propTypes = {
	    /**
	     * An optional style to apply to the overlay.
	     */
	    style: _propTypes2.default.object,
	
	    /**
	     * An optional className to apply to the overlay.
	     */
	    className: _propTypes2.default.string,
	
	    /**
	     * Any children to display in the overlay. This is _normally_ a `CardTitle` component
	     * or some buttons.
	     */
	    children: _propTypes2.default.node,
	
	    /**
	     * The component to be rendered as.
	     */
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	  };
	  MediaOverlay.defaultProps = {
	    component: 'div'
	  };
	  exports.default = MediaOverlay;
	});

/***/ }),

/***/ "./node_modules/react-md/lib/Media/index.js":
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__("./node_modules/react-md/lib/Media/Media.js"), __webpack_require__("./node_modules/react-md/lib/Media/MediaOverlay.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Media'), require('./MediaOverlay'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Media, global.MediaOverlay);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Media, _MediaOverlay2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.MediaOverlay = exports.Media = undefined;
	
	  var _Media2 = _interopRequireDefault(_Media);
	
	  var _MediaOverlay3 = _interopRequireDefault(_MediaOverlay2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Media2.default;
	  exports.Media = _Media2.default;
	  exports.MediaOverlay = _MediaOverlay3.default;
	});

/***/ }),

/***/ "./src/components/Listing/Listing.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Preview = __webpack_require__("./src/components/Preview/Preview.jsx");
	
	var _Preview2 = _interopRequireDefault(_Preview);
	
	var _products = __webpack_require__("./data/products.js");
	
	var _products2 = _interopRequireDefault(_products);
	
	var _community = __webpack_require__("./data/community.js");
	
	var _community2 = _interopRequireDefault(_community);
	
	__webpack_require__("./src/components/Listing/Listing.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostListing = function (_React$Component) {
	    _inherits(PostListing, _React$Component);
	
	    function PostListing() {
	        _classCallCheck(this, PostListing);
	
	        return _possibleConstructorReturn(this, (PostListing.__proto__ || Object.getPrototypeOf(PostListing)).apply(this, arguments));
	    }
	
	    _createClass(PostListing, [{
	        key: "render",
	        value: function render() {
	            var community = this.props.community;
	            // const itemList = community ? communityData : productData;
	
	            var content = _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    { className: "full-iframe" },
	                    _react2.default.createElement("iframe", { src: "/pages/tdh/index.html" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "full-iframe" },
	                    _react2.default.createElement("iframe", { src: "/pages/tdah/index.html" })
	                )
	            );
	
	            if (community) {
	                content = _react2.default.createElement(
	                    "div",
	                    { className: "full-iframe" },
	                    _react2.default.createElement("iframe", { src: "/pages/bhh/index.html" })
	                );
	            }
	            // if (itemList.length > 0) {
	            //   content = (
	            //     <div className="md-grid md-cell--12 mobile-fix">
	            //       {itemList.map(item => <Preview key={item.name} item={item} />)}
	            //     </div>
	            //   );
	            // }
	            return content;
	        }
	    }]);
	
	    return PostListing;
	}(_react2.default.Component);
	
	exports.default = PostListing;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Listing/Listing.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./src/components/Preview/Preview.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__("./node_modules/react-md/lib/Cards/Card.js");
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardTitle = __webpack_require__("./node_modules/react-md/lib/Cards/CardTitle.js");
	
	var _CardTitle2 = _interopRequireDefault(_CardTitle);
	
	var _CardText = __webpack_require__("./node_modules/react-md/lib/Cards/CardText.js");
	
	var _CardText2 = _interopRequireDefault(_CardText);
	
	var _Media = __webpack_require__("./node_modules/react-md/lib/Media/index.js");
	
	var _Media2 = _interopRequireDefault(_Media);
	
	__webpack_require__("./src/components/Preview/Preview.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Preview = function (_Component) {
	  _inherits(Preview, _Component);
	
	  function Preview(props) {
	    _classCallCheck(this, Preview);
	
	    var _this = _possibleConstructorReturn(this, (Preview.__proto__ || Object.getPrototypeOf(Preview)).call(this, props));
	
	    _this.state = {
	      mobile: true
	    };
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(Preview, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.handleResize();
	      window.addEventListener("resize", this.handleResize);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener("resize", this.handleResize);
	    }
	  }, {
	    key: "handleResize",
	    value: function handleResize() {
	      if (window.innerWidth >= 640) {
	        this.setState({ mobile: false });
	      } else {
	        this.setState({ mobile: true });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var item = this.props.item;
	      var mobile = this.state.mobile;
	
	      var coverHeight = mobile ? 200 : 300;
	      return _react2.default.createElement(
	        _Card2.default,
	        { key: item.name, raise: true, className: "md-grid md-cell md-cell--12" },
	        _react2.default.createElement(
	          _Media2.default,
	          {
	            style: {
	              backgroundImage: "url(" + item.cover + ")",
	              height: coverHeight + "px"
	            },
	            className: "preview-cover"
	          },
	          _react2.default.createElement(
	            _Media.MediaOverlay,
	            null,
	            _react2.default.createElement(_CardTitle2.default, { title: item.name })
	          )
	        ),
	        _react2.default.createElement(
	          _CardText2.default,
	          null,
	          item.description
	        )
	      );
	    }
	  }]);
	
	  return Preview;
	}(_react.Component);
	
	exports.default = Preview;
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/Preview/Preview.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/community.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Listing = __webpack_require__("./src/components/Listing/Listing.jsx");
	
	var _Listing2 = _interopRequireDefault(_Listing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CommunityPage = function (_Component) {
	  _inherits(CommunityPage, _Component);
	
	  function CommunityPage() {
	    _classCallCheck(this, CommunityPage);
	
	    return _possibleConstructorReturn(this, (CommunityPage.__proto__ || Object.getPrototypeOf(CommunityPage)).apply(this, arguments));
	  }
	
	  _createClass(CommunityPage, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_Listing2.default, { community: true });
	    }
	  }]);
	
	  return CommunityPage;
	}(_react.Component);
	
	exports.default = CommunityPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-community-jsx-caccd7b1e6ea7af1da81.js